

import React, { useState, useEffect, useRef, memo } from "react";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,

} from "@mui/material";

import HearingTestUi from "./HearingTestUI";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import PhaseTwoUI from "./PhaseTwoUI";
import PhaseOneUI from "./PhaseOneUi";
import HearingTestMainUi from "./HearingTestMainUi";
import useValidate from "../../store/hooks/useValidator"
import { useDispatch } from 'react-redux'
import { callApiAction } from "../../store/actions/commonAction"
import { UpdatePatientApi } from "../../apis/patient.api";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";

const audioContext = new (window.AudioContext || window.webkitAudioContext)();

const NavigationButtons = ({
  phase,
  setPhase,
  maxPhase,
  frequency,
  setOctaveFreq,
  selectedTone,
}) => {
  const handleNextPhase = () => {
    if (phase === 5) {
      if (selectedTone === "A") {
        setOctaveFreq(frequency / 2);
      } else if (selectedTone === "B") {
        setOctaveFreq(frequency);
      } else if (selectedTone === "C") {
        setOctaveFreq(frequency * 2);
      }
    }
    setPhase(phase + 1);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        display: "flex",
        gap: 2,
      }}
    >
      {phase > 1 && (
        <Button
          variant="contained"
          onClick={() => setPhase(phase - 1)}
          sx={{
            bgcolor: "#d34646",
            "&:hover": {
              bgcolor: "#b83b3b",
            },
            width: "130px",
            height: "5vh",
          }}
        >
          Back
        </Button>
      )}
      {phase < maxPhase && (
        <Button
          variant="contained"
          onClick={handleNextPhase}
          sx={{
            bgcolor: "#d34646",
            "&:hover": {
              bgcolor: "#b83b3b",
            },
            width: "130px",
            height: "5vh",
          }}
        >
          Next
        </Button>
      )}
      {phase===maxPhase && (
        <Button
          variant="contained"
         // onClick={handleSubmit}
          sx={{
            bgcolor: "#d34646",
            "&:hover": {
              bgcolor: "#b83b3b",
            },
            width: "130px",
            height: "5vh",
          }}
        >
          Submit
        </Button>
      )}
    </Box>
  );
};

const HearingTestController = ({ callBack = () => {} }) => {
  const validate = useValidate()
  const dispatch = useDispatch()
  const location = useLocation();
   const navigate = useNavigate();
  const params = useParams();
  const [comfortableLoudness, setComfortableLoudness] = useState(50);
  const [selectedWave, setSelectedWave] = useState("sine");
  const [selectedEar, setSelectedEar] = useState("both");
  const [frequency, setFrequency] = useState(1000);
  const [isPlaying, setIsPlaying] = useState(false);
  const [phase, setPhase] = useState(1);
  
  const [selectedTone, setSelectedTone] = useState("B");
  const [tinnitusLoudness, setTinnitusLoudness] = useState(50);
  const [currentNoiseSource, setCurrentNoiseSource] = useState(null);
  const [isNoisePlaying, setIsNoisePlaying] = useState(false);
  const [selectedNoise, setSelectedNoise] = useState("white"); 
  const [loading,setLoading]= useState()
  const [octaveFreq, setOctaveFreq] = useState(null);
  useEffect(( ) => {
    setOctaveFreq(frequency)
  }, [frequency])

  useEffect(() => {
    setFields((prevFields) => ({
      ...prevFields,
      loudness: tinnitusLoudness,
      frequency: octaveFreq,
    }));
  }, [tinnitusLoudness, octaveFreq]);

const[fields, setFields] = useState({
  err:'',
  id:params?.id,
  loudness:tinnitusLoudness ,
  frequency: octaveFreq
})

const validationSchemaForCreate = memo(() => ([

  {
      required: true,
      value: fields.loudness,
      field: 'loudness',
  },
  {
      required: true,
      value: fields.frequency,
      field: 'frequency'
  },
  {
      required: true,
      value: fields.id,
      field: 'id',
  },
  
]), [fields])

const onSubmit = async () => {
  setLoading(true);

  dispatch(
      callApiAction(
          async () => await UpdatePatientApi(fields),
          async (response) => {
              await callBack(response);
              setLoading(false);

              // Show snackbar
              dispatch(
                  callSnackBar(
                      "Test Completed",
                      SNACK_BAR_VARIETNS.suceess
                  )
              );

              // Navigate immediately
              navigate(`/Patient-Details/${params.id}`);
          },
          (err) => {
              setLoading(false);
              setFields({ ...fields, err });
          }
      )
  );
};


  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const maxPhase = 7;
  useEffect(() => {
    return () => {
      if (audioContext && audioContext.state !== 'closed') {
        audioContext.close().then(() => {
          console.log("AudioContext closed successfully.");
        }).catch((error) => {
          console.error("Error closing AudioContext:", error);
        });
      }
    };
  }, []);



  const playSound = (freq, gainValue = comfortableLoudness) => {
    if (selectedWave === "narrowband") {
      playNarrowbandNoise(freq, gainValue);
    } else {
      const oscillator = audioContext.createOscillator();
      oscillator.type = selectedWave;
      oscillator.frequency.setValueAtTime(freq, audioContext.currentTime);

      const gainNode = audioContext.createGain();

      const linearGain = Math.pow(10, (gainValue - 105) / 20);

      gainNode.gain.setValueAtTime(linearGain, audioContext.currentTime);

      const panner = audioContext.createStereoPanner();

      if (phase === 1) {
        panner.pan.setValueAtTime(0, audioContext.currentTime);
      } else {
        if (selectedEar === "left") {
          panner.pan.setValueAtTime(1, audioContext.currentTime);
        } else if (selectedEar === "right") {
          panner.pan.setValueAtTime(-1, audioContext.currentTime);
        } else {
          panner.pan.setValueAtTime(0, audioContext.currentTime);
        }
      }

      oscillator.connect(gainNode);
      gainNode.connect(panner);
      panner.connect(audioContext.destination);

      oscillator.start();
      setTimeout(() => {
        oscillator.stop();
      }, 1500);
    }
  };

  const handlePlayTone = (tone, freq) => {
    setIsPlaying(tone);
    playSound(freq);

    setTimeout(() => setIsPlaying(false), 1500);
  };

  const handleSelectTone = (tone) => {
    setSelectedTone(tone);
  };

  const handleLoudnessTest = () => {
    setIsPlaying(true);
    playSound(1000, comfortableLoudness);
    setTimeout(() => setIsPlaying(false), 1500);
  };

  const handleFrequencyTest = () => {
    setIsPlaying(true);
    playSound(frequency);
    setTimeout(() => setIsPlaying(false), 1500);
  };

  const handleTinnitusLoudnessTest = () => {
    setIsPlaying(true);
    playSound(octaveFreq, tinnitusLoudness);
    setTimeout(() => setIsPlaying(false), 1500);
  };

  const handleWhiteNoiseWithNotch = () => {
    if (currentNoiseSource) {
      currentNoiseSource.stop();
      setCurrentNoiseSource(null);
    }

    const bufferSize = 2 * audioContext.sampleRate;
    const noiseBuffer = audioContext.createBuffer(
      1,
      bufferSize,
      audioContext.sampleRate
    );
    const output = noiseBuffer.getChannelData(0);

    for (let i = 0; i < bufferSize; i++) {
      output[i] = Math.random() * 2 - 1;
    }

    const whiteNoise = audioContext.createBufferSource();
    whiteNoise.buffer = noiseBuffer;
    whiteNoise.loop = true;

    const upperOctaveFreq = octaveFreq * Math.pow(2, 1 / 6);
    const lowerOctaveFreq = octaveFreq * Math.pow(2, -1 / 6);
    const octaveBandwidth = upperOctaveFreq - lowerOctaveFreq;

    const biquadFilter = audioContext.createBiquadFilter();
    biquadFilter.type = "notch";
    biquadFilter.frequency.setValueAtTime(octaveFreq, audioContext.currentTime);
    biquadFilter.Q.value = octaveFreq / octaveBandwidth;

    const gainNode = audioContext.createGain();
    const linearGain = Math.pow(10, (tinnitusLoudness - 110) / 20);
    gainNode.gain.setValueAtTime(linearGain, audioContext.currentTime);

    const panner = audioContext.createStereoPanner();
    if (selectedEar === "left")
      panner.pan.setValueAtTime(-1, audioContext.currentTime);
    else if (selectedEar === "right")
      panner.pan.setValueAtTime(1, audioContext.currentTime);
    else panner.pan.setValueAtTime(0, audioContext.currentTime);

    whiteNoise.connect(biquadFilter);
    biquadFilter.connect(gainNode);
    gainNode.connect(panner);
    panner.connect(audioContext.destination);

    whiteNoise.start();
    setCurrentNoiseSource(whiteNoise);
    setIsNoisePlaying(true);
  };



  const handlePinkNoiseWithNotch = () => {
    if (currentNoiseSource) {
      currentNoiseSource.stop();
      setCurrentNoiseSource(null);
    }

    const bufferSize = 2 * audioContext.sampleRate;
    const noiseBuffer = audioContext.createBuffer(
      1,
      bufferSize,
      audioContext.sampleRate
    );
    const output = noiseBuffer.getChannelData(0);

    let b0, b1, b2, b3, b4, b5, b6;
    b0 = b1 = b2 = b3 = b4 = b5 = b6 = 0.0;

    for (let i = 0; i < bufferSize; i++) {
      let white = Math.random() * 2 - 1;
      b0 = 0.99886 * b0 + white * 0.0555179;
      b1 = 0.99332 * b1 + white * 0.0750759;
      b2 = 0.969 * b2 + white * 0.153852;
      b3 = 0.8665 * b3 + white * 0.3104856;
      b4 = 0.55 * b4 + white * 0.5329522;
      b5 = -0.7616 * b5 - white * 0.016898;
      output[i] = b0 + b1 + b2 + b3 + b4 + b5 + b6 + white * 0.5362;
      output[i] *= 0.11;
      b6 = white * 0.115926;
    }

    const pinkNoise = audioContext.createBufferSource();
    pinkNoise.buffer = noiseBuffer;
    pinkNoise.loop = true;

    const upperOctaveFreq = octaveFreq * Math.pow(2, 1 / 6);
    const lowerOctaveFreq = octaveFreq * Math.pow(2, -1 / 6);
    const octaveBandwidth = upperOctaveFreq - lowerOctaveFreq;

    const biquadFilter = audioContext.createBiquadFilter();
    biquadFilter.type = "notch";
    biquadFilter.frequency.setValueAtTime(octaveFreq, audioContext.currentTime);
    biquadFilter.Q.value = octaveFreq / octaveBandwidth;

    const gainNode = audioContext.createGain();
    const linearGain = Math.pow(10, (tinnitusLoudness - 95) / 20);
    gainNode.gain.setValueAtTime(linearGain, audioContext.currentTime);

    const panner = audioContext.createStereoPanner();
    if (selectedEar === "left")
      panner.pan.setValueAtTime(-1, audioContext.currentTime);
    else if (selectedEar === "right")
      panner.pan.setValueAtTime(1, audioContext.currentTime);
    else panner.pan.setValueAtTime(0, audioContext.currentTime);

    pinkNoise.connect(biquadFilter);
    biquadFilter.connect(gainNode);
    gainNode.connect(panner);
    panner.connect(audioContext.destination);

    pinkNoise.start();
    setCurrentNoiseSource(pinkNoise);
    setIsNoisePlaying(true);
  };



  const handleBrownNoiseWithNotch = () => {
    if (currentNoiseSource) {
      currentNoiseSource.stop();
      setCurrentNoiseSource(null);
    }

    const bufferSize = 2 * audioContext.sampleRate;
    const noiseBuffer = audioContext.createBuffer(
      1,
      bufferSize,
      audioContext.sampleRate
    );
    const output = noiseBuffer.getChannelData(0);

    let lastOut = 0.0;
    for (let i = 0; i < bufferSize; i++) {
      let white = Math.random() * 2 - 1;
      output[i] = (lastOut + 0.02 * white) / 1.02;
      lastOut = output[i];
      output[i] *= 3.5;
    }

    const brownNoise = audioContext.createBufferSource();
    brownNoise.buffer = noiseBuffer;
    brownNoise.loop = true;

    const upperOctaveFreq = octaveFreq * Math.pow(2, 1 / 6);
    const lowerOctaveFreq = octaveFreq * Math.pow(2, -1 / 6);
    const octaveBandwidth = upperOctaveFreq - lowerOctaveFreq;

    const biquadFilter = audioContext.createBiquadFilter();
    biquadFilter.type = "notch";
    biquadFilter.frequency.setValueAtTime(octaveFreq, audioContext.currentTime);
    biquadFilter.Q.value = octaveFreq / octaveBandwidth;

    const gainNode = audioContext.createGain();
    const linearGain = Math.pow(10, (tinnitusLoudness - 90) / 20);
    gainNode.gain.setValueAtTime(linearGain, audioContext.currentTime);

    const panner = audioContext.createStereoPanner();
    if (selectedEar === "left")
      panner.pan.setValueAtTime(-1, audioContext.currentTime);
    else if (selectedEar === "right")
      panner.pan.setValueAtTime(1, audioContext.currentTime);
    else panner.pan.setValueAtTime(0, audioContext.currentTime);

    brownNoise.connect(biquadFilter);
    biquadFilter.connect(gainNode);
    gainNode.connect(panner);
    panner.connect(audioContext.destination);

    brownNoise.start();
    setCurrentNoiseSource(brownNoise);
    setIsNoisePlaying(true);
  };

  

  const handlePlayPauseNoise = () => {
    if (isNoisePlaying) {
      handlePauseNoise();
    } else {
      switch (selectedNoise) {
        case "white":
          handleWhiteNoiseWithNotch();
          break;
        case "pink":
          handlePinkNoiseWithNotch();
          break;
        case "brown":
          handleBrownNoiseWithNotch();
          break;
        default:
          break;
      }
    }
  };

  const handlePauseNoise = () => {
    if (currentNoiseSource) {
      currentNoiseSource.stop();
      setIsNoisePlaying(false);
      setCurrentNoiseSource(null);
    }
  };

  const playNarrowbandNoise = (centerFreq, gainValue = comfortableLoudness) => {
    setIsPlaying(true);

    const upperFreq = centerFreq * Math.pow(2, 1 / 6);
    const lowerFreq = centerFreq * Math.pow(2, -1 / 6);

    const bandwidth = upperFreq - lowerFreq;

    const bufferSize = 2 * audioContext.sampleRate;
    const noiseBuffer = audioContext.createBuffer(
      1,
      bufferSize,
      audioContext.sampleRate
    );
    const output = noiseBuffer.getChannelData(0);

    for (let i = 0; i < bufferSize; i++) {
      output[i] = Math.random() * 2 - 1;
    }

    const whiteNoise = audioContext.createBufferSource();
    whiteNoise.buffer = noiseBuffer;

    const bandpassFilter = audioContext.createBiquadFilter();
    bandpassFilter.type = "bandpass";
    bandpassFilter.frequency.setValueAtTime(
      centerFreq,
      audioContext.currentTime
    );

    bandpassFilter.Q.value = centerFreq / bandwidth;


    const gainNode = audioContext.createGain();
    const linearGain = Math.pow(10, (gainValue - 100) / 20);
    gainNode.gain.setValueAtTime(linearGain, audioContext.currentTime);


    const panner = audioContext.createStereoPanner();

  
    if (selectedEar === "left") {
      panner.pan.setValueAtTime(1, audioContext.currentTime); 
    } else if (selectedEar === "right") {
      panner.pan.setValueAtTime(-1, audioContext.currentTime); 
    } else {
      panner.pan.setValueAtTime(0, audioContext.currentTime); 
    }

  
    whiteNoise.connect(bandpassFilter);
    bandpassFilter.connect(gainNode);
    gainNode.connect(panner);
    panner.connect(audioContext.destination);

    whiteNoise.start();

    setTimeout(() => {
      whiteNoise.stop();
      setIsPlaying(false);
    }, 1500);
  };

  const increaseLoudness = () =>
    setComfortableLoudness(Math.min(100, comfortableLoudness + 10));

  const decreaseLoudness = () =>
    setComfortableLoudness(Math.max(10, comfortableLoudness - 10));

  const increaseTinnitusLoudness = () =>
    setTinnitusLoudness(Math.min(100, tinnitusLoudness + 5));

  const decreaseTinnitusLoudness = () =>
    setTinnitusLoudness(Math.max(10, tinnitusLoudness - 5));

  const increaseFreq = () => setFrequency(Math.min(20000, frequency + 100));

  const decreaseFreq = () => setFrequency(Math.max(100, frequency - 100));

  const handleFrequencyChange = (e) => {
    const input = e.target.value;
    if (input === "" || Number(input) <= 20000) {
      setFrequency(parseInt(input));
    }
  };

   const canvasRef = useRef(null);
    const [phaseShift, setPhaseShift] = useState(0); // Controls wave motion
    const animationRef = useRef(null); // Ref for animation frame
    
    // Draw dynamic wave based on frequency and phase shift
    const drawWave = (frequency, phaseShift, waveType) => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
    
      // Canvas dimensions
      const width = canvas.width;
      const height = canvas.height;
    
      // Clear the canvas
      ctx.clearRect(0, 0, width, height);
    
      // Wave properties
      const amplitude = height / 4; // Wave height
      const wavelength = width / (frequency / 100); // Wave length
      const centerY = height / 2;
    
      // Narrowband noise properties
      const bandWidthFactor = 0.1; // Adjust randomness (lower = smoother)
      const maxBandOffset = frequency * bandWidthFactor; // Frequency spread
      const segmentSize = 5; // Smooth randomness per segment
    
      // Draw wave
      ctx.beginPath();
      ctx.moveTo(0, centerY);
    
      for (let x = 0; x < width; x++) {
        let y;
    
        switch (waveType) {
          case "sine":
            y =
              amplitude *
                Math.sin((2 * Math.PI * x) / wavelength + phaseShift) +
              centerY;
            break;
          case "square":
            y =
              amplitude *
                Math.sign(Math.sin((2 * Math.PI * x) / wavelength + phaseShift)) +
              centerY;
            break;
          case "sawtooth":
            y =
              amplitude *
                (2 * ((x / wavelength + phaseShift / (2 * Math.PI)) % 1) - 1) +
              centerY;
            break;
          case "narrowband":
            // Create smoother transitions in narrowband noise
            const randomFreq =
              frequency + Math.sin(x / segmentSize) * maxBandOffset;
            y =
              amplitude *
                Math.sin((2 * Math.PI * x) / (width / randomFreq) + phaseShift) +
              centerY;
            break;
          default:
            y = centerY; // Default to flat line
        }
    
        ctx.lineTo(x, y);
      }
    
      ctx.strokeStyle = "#d34646"; // Primary color
      ctx.lineWidth = 2;
      ctx.stroke();
    };
    
    
    // Animate wave
    const animateWave = () => {
      setPhaseShift((prev) => prev + 0.4); // Adjust speed of wave motion
      animationRef.current = requestAnimationFrame(animateWave);
    };
    
    // Start wave animation and stop after 5 seconds
    const startWaveAnimation = () => {
      if (!animationRef.current) {
        animationRef.current = requestAnimationFrame(animateWave);
        setTimeout(() => {
          cancelAnimationFrame(animationRef.current);
          animationRef.current = null; // Reset animation ref
        }, 2000); // Stop after 5 seconds
      }
    };
    
    // Redraw wave when frequency or phase shift changes
    useEffect(() => {
      drawWave(frequency, phaseShift, selectedWave);
    }, [frequency, phaseShift, selectedWave]);
    

/*download noise handler for testing only  do not delete this code*/

// const handleDownloadPinkNoiseWithNotch = () => {
//   const duration = 10; // Duration in seconds

// const bufferSize = 2 * audioContext.sampleRate;
// const noiseBuffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate);
// const output = noiseBuffer.getChannelData(0);

// let b0, b1, b2, b3, b4, b5, b6;
// b0 = b1 = b2 = b3 = b4 = b5 = b6 = 0.0;

// for (let i = 0; i < bufferSize; i++) {
//   let white = Math.random() * 2 - 1;
//   b0 = 0.99886 * b0 + white * 0.0555179;
//   b1 = 0.99332 * b1 + white * 0.0750759;
//   b2 = 0.96900 * b2 + white * 0.1538520;
//   b3 = 0.86650 * b3 + white * 0.3104856;
//   b4 = 0.55000 * b4 + white * 0.5329522;
//   b5 = -0.7616 * b5 - white * 0.0168980;
//   output[i] = b0 + b1 + b2 + b3 + b4 + b5 + b6 + white * 0.5362;
//   output[i] *= 0.11; // compensate for gain
//   b6 = white * 0.115926;
// }

// const pinkNoise = audioContext.createBufferSource();
// pinkNoise.buffer = noiseBuffer;
// pinkNoise.loop = true; // Loop the noise

//   // Apply notch filter
//   const upperOctaveFreq = octaveFreq * Math.pow(2, 1 / 6);
//   const lowerOctaveFreq = octaveFreq * Math.pow(2, -1 / 6);
//   const octaveBandwidth = upperOctaveFreq - lowerOctaveFreq;

//   const biquadFilter = audioContext.createBiquadFilter();
//   biquadFilter.type = "notch";
//   biquadFilter.frequency.setValueAtTime(octaveFreq, audioContext.currentTime);
//   biquadFilter.Q.value = octaveFreq / octaveBandwidth;
//   // Apply loudness adjustment using gainNode
//   const gainNode = audioContext.createGain();
//   const linearGain = Math.pow(10, (tinnitusLoudness - 95) / 20); // Convert dB to linear gain
//   gainNode.gain.setValueAtTime(linearGain, audioContext.currentTime);

//   // Create a stereo panner node for controlling which ear the sound plays in
//   const panner = audioContext.createStereoPanner();
//   if (selectedEar === "left") {
//     panner.pan.setValueAtTime(-1, audioContext.currentTime); // Play in the left ear
//   } else if (selectedEar === "right") {
//     panner.pan.setValueAtTime(1, audioContext.currentTime); // Play in the right ear
//   } else {
//     panner.pan.setValueAtTime(0, audioContext.currentTime); // Play in both ears
//   }

//   // Connect the nodes: whiteNoise -> biquadFilter -> gainNode -> panner -> both destination and MediaStreamDestination
//   pinkNoise.connect(biquadFilter);
//   biquadFilter.connect(gainNode);
//   gainNode.connect(panner);

//   // Create a media stream destination for recording
//   const destination = audioContext.createMediaStreamDestination();

//   // Connect the panner to both the audio output and the recording destination
//   panner.connect(audioContext.destination); // To play the sound
//   panner.connect(destination);              // To record the sound

//   // Create a media recorder for the destination stream
//   const mediaRecorder = new MediaRecorder(destination.stream);

//   let audioChunks = [];
//   mediaRecorder.ondataavailable = (event) => {
//     audioChunks.push(event.data);
//   };

//   mediaRecorder.onstop = () => {
//     // Create a Blob from the audio chunks
//     const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });

//     // Create a download link for the audio
//     const url = window.URL.createObjectURL(audioBlob);
//     const a = document.createElement('a');
//     a.style.display = 'none';
//     a.href = url;
//     a.download = 'pink_noise_with_notch.wav';
//     document.body.appendChild(a);
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   // Start recording
//   mediaRecorder.start();

//   // Start the white noise and stop after 10 seconds
//   pinkNoise.start();
//   setTimeout(() => {
//     pinkNoise.stop();
//     mediaRecorder.stop(); // Stop recording after white noise finishes
//   }, duration * 1000); // Play for 10 seconds
// };

// const handleDownloadWhiteNoiseWithNotch = () => {
//   const duration = 10; // Duration in seconds
//   const bufferSize = audioContext.sampleRate * duration; // Buffer size for 10 seconds
//   const noiseBuffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate);
//   const output = noiseBuffer.getChannelData(0);

//   // Generate white noise
//   for (let i = 0; i < bufferSize; i++) {
//     output[i] = Math.random() * 2 - 1; // White noise
//   }

//   const whiteNoise = audioContext.createBufferSource();
//   whiteNoise.buffer = noiseBuffer;

//   // Apply notch filter
//   const upperOctaveFreq = octaveFreq * Math.pow(2, 1 / 6);
//   const lowerOctaveFreq = octaveFreq * Math.pow(2, -1 / 6);
//   const octaveBandwidth = upperOctaveFreq - lowerOctaveFreq;

//   const biquadFilter = audioContext.createBiquadFilter();
//   biquadFilter.type = "notch";
//   biquadFilter.frequency.setValueAtTime(octaveFreq, audioContext.currentTime);
//   biquadFilter.Q.value = octaveFreq / octaveBandwidth;
//   // Apply loudness adjustment using gainNode
//   const gainNode = audioContext.createGain();
//   const linearGain = Math.pow(10, (tinnitusLoudness - 110) / 20); // Convert dB to linear gain
//   gainNode.gain.setValueAtTime(linearGain, audioContext.currentTime);

//   // Create a stereo panner node for controlling which ear the sound plays in
//   const panner = audioContext.createStereoPanner();
//   if (selectedEar === "left") {
//     panner.pan.setValueAtTime(-1, audioContext.currentTime); // Play in the left ear
//   } else if (selectedEar === "right") {
//     panner.pan.setValueAtTime(1, audioContext.currentTime); // Play in the right ear
//   } else {
//     panner.pan.setValueAtTime(0, audioContext.currentTime); // Play in both ears
//   }

//   // Connect the nodes: whiteNoise -> biquadFilter -> gainNode -> panner -> both destination and MediaStreamDestination
//   whiteNoise.connect(biquadFilter);
//   biquadFilter.connect(gainNode);
//   gainNode.connect(panner);

//   // Create a media stream destination for recording
//   const destination = audioContext.createMediaStreamDestination();

//   // Connect the panner to both the audio output and the recording destination
//   panner.connect(audioContext.destination); // To play the sound
//   panner.connect(destination);              // To record the sound

//   // Create a media recorder for the destination stream
//   const mediaRecorder = new MediaRecorder(destination.stream);

//   let audioChunks = [];
//   mediaRecorder.ondataavailable = (event) => {
//     audioChunks.push(event.data);
//   };

//   mediaRecorder.onstop = () => {
//     // Create a Blob from the audio chunks
//     const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });

//     // Create a download link for the audio
//     const url = window.URL.createObjectURL(audioBlob);
//     const a = document.createElement('a');
//     a.style.display = 'none';
//     a.href = url;
//     a.download = 'white_noise_with_notch.wav';
//     document.body.appendChild(a);
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   // Start recording
//   mediaRecorder.start();

//   // Start the white noise and stop after 10 seconds
//   whiteNoise.start();
//   setTimeout(() => {
//     whiteNoise.stop();
//     mediaRecorder.stop(); // Stop recording after white noise finishes
//   }, duration * 1000); // Play for 10 seconds
// };

// const handleDownloadBrownNoiseWithNotch = () => {
//   const duration = 10; // Duration in seconds
//   const bufferSize = 2 * audioContext.sampleRate;
//   const noiseBuffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate);
//   const output = noiseBuffer.getChannelData(0);

//   let lastOut = 0.0;
//   for (let i = 0; i < bufferSize; i++) {
//     let white = Math.random() * 2 - 1;
//     output[i] = (lastOut + (0.02 * white)) / 1.02;
//     lastOut = output[i];
//     output[i] *= 3.5;
//   }

//   const brownNoise = audioContext.createBufferSource();
//   brownNoise.buffer = noiseBuffer;
//   brownNoise.loop = true; // Loop the noise

//   const upperOctaveFreq = octaveFreq * Math.pow(2, 1 / 6);
//   const lowerOctaveFreq = octaveFreq * Math.pow(2, -1 / 6);
//   const octaveBandwidth = upperOctaveFreq - lowerOctaveFreq;

//   const biquadFilter = audioContext.createBiquadFilter();
//   biquadFilter.type = "notch";
//   biquadFilter.frequency.setValueAtTime(octaveFreq, audioContext.currentTime);
//   biquadFilter.Q.value = octaveFreq / octaveBandwidth;

//   // Apply loudness adjustment using gainNode
//   const gainNode = audioContext.createGain();
//   const linearGain = Math.pow(10, (tinnitusLoudness - 90) / 20); // Convert dB to linear gain
//   gainNode.gain.setValueAtTime(linearGain, audioContext.currentTime);

//   // Create a stereo panner node for controlling which ear the sound plays in
//   const panner = audioContext.createStereoPanner();
//   if (selectedEar === "left") {
//     panner.pan.setValueAtTime(-1, audioContext.currentTime); // Play in the left ear
//   } else if (selectedEar === "right") {
//     panner.pan.setValueAtTime(1, audioContext.currentTime); // Play in the right ear
//   } else {
//     panner.pan.setValueAtTime(0, audioContext.currentTime); // Play in both ears
//   }

//   // Connect the nodes: whiteNoise -> biquadFilter -> gainNode -> panner -> both destination and MediaStreamDestination
//   brownNoise.connect(biquadFilter);
//   biquadFilter.connect(gainNode);
//   gainNode.connect(panner);

//   // Create a media stream destination for recording
//   const destination = audioContext.createMediaStreamDestination();

//   // Connect the panner to both the audio output and the recording destination
//   panner.connect(audioContext.destination); // To play the sound
//   panner.connect(destination);              // To record the sound

//   // Create a media recorder for the destination stream
//   const mediaRecorder = new MediaRecorder(destination.stream);

//   let audioChunks = [];
//   mediaRecorder.ondataavailable = (event) => {
//     audioChunks.push(event.data);
//   };

//   mediaRecorder.onstop = () => {
//     // Create a Blob from the audio chunks
//     const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });

//     // Create a download link for the audio
//     const url = window.URL.createObjectURL(audioBlob);
//     const a = document.createElement('a');
//     a.style.display = 'none';
//     a.href = url;
//     a.download = 'white_noise_with_notch.wav';
//     document.body.appendChild(a);
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   // Start recording
//   mediaRecorder.start();

//   // Start the white noise and stop after 10 seconds
//   brownNoise.start();
//   setTimeout(() => {
//     brownNoise.stop();
//     mediaRecorder.stop(); // Stop recording after white noise finishes
//   }, duration * 1000); // Play for 10 seconds
// };

  return (
   <>

      {/* <NavigationButtons
        phase={phase}
        setPhase={setPhase}
        maxPhase={maxPhase}
        selectedTone={selectedTone}
        setOctaveFreq={setOctaveFreq}
        frequency={frequency}
      /> */}
{/* <Typography>{location.state.Patient.name} ( {location.state.Patient._id} ) </Typography> */}

{/* <PhaseTwoUI
selectedEar={selectedEar}
setSelectedEar={setSelectedEar}/>

<PhaseOneUI
handleLoudnessTest={handleLoudnessTest}
isPlaying={isPlaying}
comfortableLoudness={comfortableLoudness}
setComfortableLoudness={setComfortableLoudness}/>  */}

<HearingTestMainUi
        comfortableLoudness={comfortableLoudness}
        setComfortableLoudness={setComfortableLoudness}
        selectedWave={selectedWave}
        canvasRef={canvasRef}
        startWaveAnimation={startWaveAnimation}
        setSelectedWave={setSelectedWave}
        selectedEar ={selectedEar}
        setSelectedEar={setSelectedEar}
        frequency={frequency}
        setFrequency={setFrequency}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
        phase={phase}
        setPhase={setPhase}
        octaveFreq={octaveFreq}
        onSubmit={onSubmit}
        // setOctaveFreq={setOctaveFreq}
        selectedTone={selectedTone}
        setSelectedTone={setSelectedTone}
        tinnitusLoudness={tinnitusLoudness}
        setTinnitusLoudness={setTinnitusLoudness}
        currentNoiseSource={currentNoiseSource}
        setCurrentNoiseSource={setCurrentNoiseSource}
        isNoisePlaying={isNoisePlaying}
        setIsNoisePlaying={setIsNoisePlaying}
        selectedNoise={selectedNoise}
        setSelectedNoise={setSelectedNoise}
        playSound={playSound}
        handlePlayTone={handlePlayTone}
        handleSelectTone={handleSelectTone}
        handleLoudnessTest={handleLoudnessTest}
        handleFrequencyTest={handleFrequencyTest}
        handleTinnitusLoudnessTest={handleTinnitusLoudnessTest}
        handleWhiteNoiseWithNotch={handleWhiteNoiseWithNotch}
        handlePinkNoiseWithNotch={handlePinkNoiseWithNotch}
        handleBrownNoiseWithNotch={handleBrownNoiseWithNotch}
        handlePlayPauseNoise={handlePlayPauseNoise}
        handlePauseNoise={handlePauseNoise}
        playNarrowbandNoise={playNarrowbandNoise}
        increaseLoudness={increaseLoudness}
        decreaseLoudness={decreaseLoudness}
        increaseTinnitusLoudness={increaseTinnitusLoudness}
        decreaseTinnitusLoudness={decreaseTinnitusLoudness}
        increaseFreq={increaseFreq}
        decreaseFreq={decreaseFreq}
        isMobile={isMobile}
        handleFrequencyChange={handleFrequencyChange}
      />

      
      </>
  );
};

export default HearingTestController;
